<template>
    <Navbar />
    <div class="create-task-panel-cont">
      <button class="btn btn-primary mt-3 align-self-start" @click="() => $router.push('/zlecenia')"><i class="fa-solid fa-arrow-left"></i> &nbsp; wróć do panelu zleceń</button>
      <div class="create-task-panel-page-1">
        <h2>Dodaj zlecenie</h2>
        <form class="mt-3 create-task-panel-form" @submit="(e) => goNextStep(e)">
          <div class="form-group">
            <label for="newTaskVrid" >VRID</label>
            <input type="text" name="newTaskVrid" class="form-control" id="newTaskVrid" v-model="newTaskVrid" required>
          </div>

          <div class="form-group mt-3">
            <label for="newTaskCmpName" >nazwa firmy</label>
            <input type="text" name="newTaskCmpName" class="form-control" id="newTaskCmpName" v-model="newTaskCmpName" required>
          </div>

          <div class="form-group mt-3">
            <label for="newTaskCurrency">waluta</label>
            <input type="text" name="newTaskCurrency" class="form-control" id="newTaskCurrency" v-model="newTaskCurrency" required>
          </div>

          <div class="form-group mt-3">
            <label for="newTaskRate">stawka</label>
            <input type="number" name="newTaskRate" step="0.01" class="form-control" id="newTaskRate" v-model="newTaskRate" required>
          </div>

          <div class="form-group mt-3">
            <label for="newTaskForwarder">spedytor</label>
            <input type="text" name="newTaskForwarder" class="form-control" id="newTaskForwarder" v-model="newTaskForwarder">
          </div>

          <div class="form-group mt-3">
            <label for="newTaskDesc1">opis 1</label>
            <textarea type="text" name="newTaskDesc1" class="form-control" id="newTaskDesc1" v-model="newTaskDesc1" rows="5"></textarea>
          </div>

          <div class="form-group mt-3">
            <label for="newTaskDesc2">opis 2</label>
            <textarea type="text" name="newTaskDesc2" class="form-control" id="newTaskDesc2" v-model="newTaskDesc2" rows="5"></textarea>
          </div>

          <div class="form-group mt-3">
            <label for="newTaskDesc3">opis 3</label>
            <textarea type="text" name="newTaskDesc3" class="form-control" id="newTaskDesc3" v-model="newTaskDesc3" rows="5"></textarea>
          </div>

          <div class="new-task-bg-color-cont mt-5">
            <span>kolor tekstu</span>
            <div class="d-flex">
              <div class="new-task-bg-color-item" v-for="(color, i) in colors" :key="i" :style="{'background-color': color, 'border-width': newTaskTc == color ? '3px' : ''}" @click="newTaskTc = color"></div>
            </div>
          </div>

          <div class="new-task-bg-color-cont mt-5">
            <span>kolor komórki</span>
            <div class="d-flex">
              <div class="new-task-bg-color-item" v-for="(color, i) in colors" :key="i" :style="{'background-color': color, 'border-width': newTaskBgc == color ? '3px' : ''}" @click="newTaskBgc = color"></div>
            </div>
          </div>
          <button class="btn btn-success mt-3" type="submit">Dalej <i class="fa-solid fa-arrow-right"></i></button>
        </form>
      </div>
    </div>
  </template>

  <script>
  import Swal from 'sweetalert2'
  import Navbar from '@/components/Navbar'
  import axios from 'axios'
import { thisTypeAnnotation } from '@babel/types'

  export default {
    name: 'Step1',
    components: {
      Navbar
    },
    data () {
      return {
        colors: ['#ffffff', '#47D147', '#66FFFF', '#FFFF66', '#FF471A', '#FF9900', '#CCCCCC', '#222222'],
        newTaskBgc:'#66FFFF',
        newTaskTc:'#222222',
        newTaskVrid: '',
        newTaskCmpName: '',
        newTaskCurrency: '',
        newTaskRate: '',
        newTaskForwarder: '',
        newTaskDesc1: '',
        newTaskDesc2: '',
        newTaskDesc3: ''
      }
    },
    mounted () {
        this.fillForm()
    },
    methods: {
      goNextStep(e){
        e.preventDefault()
        const ob = {
            vrid: this.newTaskVrid,
            cmpName: this.newTaskCmpName,
            currency: this.newTaskCurrency,
            rate: this.newTaskRate,
            forwarder: this.newTaskForwarder,
            desc1: this.newTaskDesc1,
            desc2: this.newTaskDesc2,
            desc3: this.newTaskDesc3,
            bgc: this.newTaskBgc,
            tc: this.newTaskTc
        }
        this.$store.commit('setCreateTaskStepOneData', ob)
        this.$store.commit('setIsFirstStepDone', true)
        this.$router.push('/zlecenia/dodaj/2')
      },
      fillForm(){
        if(this.$store.getters.getIsFirstStepDone){
            const newTaskData = this.$store.getters.getCreateTaskStepOneData
            this.newTaskVrid = newTaskData.vrid
            this.newTaskCmpName = newTaskData.cmpName
            this.newTaskCurrency = newTaskData.currency
            this.newTaskRate = newTaskData.rate
            this.newTaskForwarder = newTaskData.forwarder
            this.newTaskDesc1 = newTaskData.desc1
            this.newTaskDesc2 = newTaskData.desc2
            this.newTaskDesc3 = newTaskData.desc3
            this.newTaskBgc = newTaskData.bgc
            this.newTaskTc = newTaskData.tc
        }
      }
    }
  }
  </script>

  <style>
    .create-task-panel-cont{
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1100px;
      margin: 0 auto;
    }
    .create-task-panel-form{
      width: 500px;
    }
    .new-task-bg-color-item{
      width: 20px;
      height: 20px;
      border: 1px solid black;
      background: none;
      margin: 10px;
      cursor: pointer;
      box-sizing: content-box;
    }
    .new-task-bg-color-cont{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  </style>
